import { Config } from '@forgerock/javascript-sdk';
import { getOAuth } from '../hooks/useJourneyHandler';
import { CMCFRSDK, useFRConfig } from './FRConfigSetup';
import { JourneyTree } from '../constants/FREnums';

export const reacquireFRTokens = async () => {
  try {
    Config.get();
  } catch {
    useFRConfig(JourneyTree.FR_JOURNEY_LOGIN);
  }

  await getOAuth();

  const tokens = (await CMCFRSDK.TokenStorage.get()) as CMCFRSDK.Tokens;

  return tokens;
};
